export default __webpack_public_path__ + "static/media/drawn-wind-turbine-icon.c1b3d6db.svg";